// Reusable legal consent checkbox for checkout flows.
// Customers must acknowledge Terms, Privacy, AI Disclaimer, and Refund Policy
// before starting payment.

import { Link } from "@tanstack/react-router";

export function LegalConsent({
  checked,
  onChange,
  id = "legal-consent",
  className = "",
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  id?: string;
  className?: string;
}) {
  return (
    <label
      htmlFor={id}
      className={`mt-4 flex cursor-pointer items-start gap-2.5 rounded-lg border border-border bg-white/70 p-3 text-xs leading-relaxed text-navy/85 hover:bg-white ${className}`.trim()}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border-border text-trust focus:ring-trust"
      />
      <span>
        I acknowledge I have read and agree to the{" "}
        <Link to="/terms" className="text-trust underline">Terms of Service</Link>,{" "}
        <Link to="/privacy" className="text-trust underline">Privacy Policy</Link>,{" "}
        <Link to="/ai-disclaimer" className="text-trust underline">AI Disclaimer</Link>, and{" "}
        <Link to="/refund-policy" className="text-trust underline">Refund Policy</Link>.
      </span>
    </label>
  );
}
